/* ==============================================================
   cart-whatsapp-maroc.js
   Rôle : Sur le marché Maroc, cache le(s) bouton(s) checkout du
          panier (page panier + drawer AJAX) et affiche un bouton
          "Commander via WhatsApp" qui envoie le contenu du panier.

   Prérequis :
   1. Dans theme.liquid, juste avant </head>, ajoute :
        <script>window.currentMarket = "{{ localization.country.iso_code }}";</script>
   2. Charge ce fichier en fin de theme.liquid, avant </body> :
        <script src="{{ 'cart-whatsapp-maroc.js' | asset_url }}" defer></script>
      (dépose d'abord le fichier dans le dossier "assets" du thème)
   3. Remplace WHATSAPP_NUMBER ci-dessous par ton numéro
      (format international, sans + ni espaces).
   ============================================================== */

(function () {
  var WHATSAPP_NUMBER = "212626305669";

  // Sélecteurs génériques des boutons checkout — adapte-les si besoin
  // en inspectant le panier avec les outils dev du navigateur.
  var CHECKOUT_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    '.cart__checkout',
    '#checkout',
    '[data-checkout-button]'
  ];

  function isMoroccoMarket() {
    return window.currentMarket === "MA";
  }

  function buildWhatsAppMessage(cart) {
    var lines = ["Bonjour, je souhaite commander :"];
    cart.items.forEach(function (item) {
      var lineTotal = (item.final_line_price / 100).toFixed(2);
      lines.push("- " + item.product_title + " x" + item.quantity + " (" + lineTotal + " " + cart.currency + ")");
    });
    lines.push("Total : " + (cart.total_price / 100).toFixed(2) + " " + cart.currency);
    return lines.join("\n");
  }

  function injectWhatsAppButton(cart) {
    if (document.getElementById("whatsapp-checkout-btn")) return; // déjà injecté

    var message = buildWhatsAppMessage(cart);
    var url = "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + encodeURIComponent(message);

    var link = document.createElement("a");
    link.id = "whatsapp-checkout-btn";
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "Commander via WhatsApp";
    link.style.cssText =
      "display:flex;align-items:center;justify-content:center;gap:8px;" +
      "background:#25D366;color:#fff;padding:14px;border-radius:4px;" +
      "text-decoration:none;font-weight:600;margin-top:10px;";

    // Ancre : après le premier bouton checkout trouvé (caché juste après)
    var anchor = document.querySelector(CHECKOUT_SELECTORS.join(","));
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(link, anchor.nextSibling);
    } else {
      document.body.appendChild(link); // fallback
    }
  }

  function hideCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_SELECTORS.join(",")).forEach(function (el) {
      el.style.display = "none";
    });
  }

  function run() {
    if (!isMoroccoMarket()) return;

    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) return;
        hideCheckoutButtons();
        injectWhatsAppButton(cart);
      });
  }

  document.addEventListener("DOMContentLoaded", run);

  // Réexécute quand le panier AJAX (drawer) se met à jour.
  // Beaucoup de thèmes déclenchent un événement custom, ex: "cart:updated".
  // Ajoute d'autres noms d'événements ici si ton thème en utilise un autre.
  document.addEventListener("cart:updated", run);
  document.addEventListener("cart:refresh", run);
})();
